<!-- 
Buttons for setting a provider contact to be promoted as primary contact.
-->
<template>
  <span>
    <our-action-button 
      v-if="showVsl && !isPromotedVslPrimary" :saving="state.saving" flat 
      icon="accessibility_new" color="primary" margins="ml-0 mr-3"
      @click="save('vsl', true)"
    >
      {{ filtered ? "Promote as primary" : "Promote as VSL primary" }}
    </our-action-button>
    <our-action-button 
      v-if="showVsl && isPromotedVslPrimary" :saving="state.saving" flat 
      icon="undo" icon-color="grey" color="error" margins="ml-0 mr-3"
      @click="save('vsl', false)"
    >
      {{ filtered ? "Demote primary" : "Demote VSL primary" }}
    </our-action-button>
    <our-action-button 
      v-if="showHelp && !isPromotedHelpPrimary" :saving="state.saving" flat 
      icon="accessibility_new" color="primary" margins="ml-0 mr-3"
      @click="save('help', true)"
    >
      {{ filtered ? "Promote as primary" : "Promote as HELP primary" }}
    </our-action-button>
    <our-action-button 
      v-if="showHelp && isPromotedHelpPrimary" :saving="state.saving" flat 
      icon="undo" icon-color="grey" color="error" margins="ml-0 mr-3"
      @click="save('help', false)"
    >
      {{ filtered ? "Demote primary" : "Demote HELP primary" }}
    </our-action-button>
  </span>
</template>

<script>
import * as action from "@/store/provider-contacts/action-types";

export default {
  props: {
    contact: {
      type: Object,
      required: true
    },
    levyCollectionType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      primary: "Primary",
      secondary: "Secondary",
      dualSector: "Dual",
      vslSector: "Vsl",
      helpSector: "Help"
    };
  },
  computed: {
    state() {
      return this.$store.state.providerContacts.flagPrimary;
    },
    vsl() {
      return !this.filtered || this.levyCollectionType == "Vsl";
    },
    help() {
      return !this.filtered || this.levyCollectionType == "Help" || this.levyCollectionType == "Upfront";
    },
    filtered() {
      return this.levyCollectionType != null;
    },
    showVsl() {
      return (
        this.vsl &&
        this.contact.synchroniseWithHits == true &&
        this.contact.vslStatus != this.primary &&
        (this.contact.sector == this.dualSector || this.contact.sector == this.vslSector)
      );
    },
    showHelp() {
      return (
        this.help &&
        this.contact.synchroniseWithHits == true &&
        this.contact.helpStatus != this.primary &&
        (this.contact.sector == this.dualSector || this.contact.sector == this.helpSector)
      );
    },
    isPromotedVslPrimary() {
      return this.contact.synchroniseWithHits == true && this.contact.promotedVslPrimary == true;
    },
    isPromotedHelpPrimary() {
      return this.contact.synchroniseWithHits == true && this.contact.promotedHelpPrimary == true;
    }
  },
  methods: {
    async save(type, primaryFlagValue) {
      await this.$store.dispatch(action.FLAG_AS_PRIMARY, {
        contactId: this.contact.id,
        type,
        newPrimaryFlagValue: primaryFlagValue
      });
    }
  }
};
</script>
